export default __webpack_public_path__ + "static/media/CF27C43C-BAE9-4D87-94FB-44ED422812AE.737faf44.jpeg";